import { HERO_PILLARS } from "../brands";

export function Hero() {
  return (
    <header className="relative overflow-hidden border-b border-jw-border">
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute -top-40 left-1/2 -translate-x-1/2 h-[520px] w-[920px] rounded-full blur-3xl opacity-40"
          style={{ background: "radial-gradient(circle, rgba(93,168,240,0.35) 0%, transparent 65%)" }}
        />
        {/* Subtle node-network suggestion via radial dots */}
        <div
          className="absolute top-10 right-10 h-64 w-64 opacity-30"
          style={{
            backgroundImage:
              "radial-gradient(circle, rgba(200,210,220,0.35) 1px, transparent 1.5px)",
            backgroundSize: "16px 16px",
            maskImage: "radial-gradient(circle, black 30%, transparent 75%)",
            WebkitMaskImage: "radial-gradient(circle, black 30%, transparent 75%)",
          }}
        />
      </div>

      <div className="relative mx-auto max-w-6xl px-6 pt-20 pb-16 sm:pt-28 sm:pb-24">
        <div className="grid lg:grid-cols-[1.4fr_1fr] gap-10 items-start">
          <div>
            <p className="font-mono text-xs tracking-[0.32em] text-jw-text-subtle uppercase">
              Jalen&nbsp;·&nbsp;Ward&nbsp;·&nbsp;Founder
            </p>

            <h1 className="mt-5 font-display text-[2.75rem] leading-[1.02] sm:text-[5rem] sm:leading-[0.98] tracking-tight">
              <span className="jw-wordmark">WARD</span>
              <br />
              <span className="text-jw-chrome-dim font-display text-3xl sm:text-5xl tracking-[0.2em] uppercase">
                Systems
              </span>
            </h1>

            <p className="mt-8 font-display text-lg sm:text-xl text-jw-chrome-bright font-medium tracking-wide">
              One vision. Four brands. Built to win.
            </p>

            <p className="mt-5 max-w-xl text-jw-text-muted text-base leading-relaxed">
              From the roof to the server rack to the gym — we build, document,
              and scale systems that perform.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-3">
              <a
                href="/brief"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md font-display text-xs font-semibold tracking-[0.16em] uppercase
                           text-jw-black bg-gradient-to-b from-jw-chrome-bright to-jw-chrome border border-jw-chrome-dim
                           transition hover:brightness-110 hover:-translate-y-px"
              >
                Founder Brief
              </a>
              <a
                href="#brands"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md font-display text-xs font-semibold tracking-[0.16em] uppercase
                           text-jw-chrome-bright bg-jw-surface-1 border border-jw-border
                           transition hover:bg-jw-surface-2 hover:border-jw-border-steel"
              >
                The Four Engines
              </a>
            </div>
          </div>

          <aside className="lg:pt-12">
            <p className="font-display text-[0.72rem] tracking-[0.28em] uppercase text-jw-chrome-dim mb-4">
              Built For
            </p>
            <ul className="space-y-3">
              {HERO_PILLARS.map((p) => (
                <li key={p} className="flex items-center gap-3">
                  <span className="h-1 w-8 bg-gradient-to-r from-jw-steel to-transparent" />
                  <span className="font-display text-xl sm:text-2xl text-jw-chrome-bright tracking-wide uppercase">
                    {p}.
                  </span>
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </header>
  );
}
